import { Filter } from 'state/ducks/space/models'
import { SearchResult } from './models'
import { FETCH_LOCATION_UNITS_REQUEST, SET_LOCATION_UNITS } from './types'

export const fetchLocationUnitsRequest = (
  params: Filter
): Readonly<{
  type: 'FETCH_LOCATION_UNITS_REQUEST'
  payload: {
    params: Filter
  }
}> => ({
  type: FETCH_LOCATION_UNITS_REQUEST,
  payload: { params },
})

export const setLocationUnits = (units: SearchResult) => ({
  type: SET_LOCATION_UNITS,
  payload: { units },
})
